// src/components/Certificates/CertificatePDFGenerator/PDFTemplate/index.tsx
import React from 'react'
import { Page, Text, View, Document, Image } from '@react-pdf/renderer'
import { CertificatePDFData } from '../types'
import { styles } from './styles'
import logoDustre from '../../../../assets/Cert/logo-dustre-cert.png'

const CertificatePDFGenerator: React.FC<{
  certificate: CertificatePDFData
}> = ({ certificate }) => {
  const renderHeader = () => (
    <View style={styles.header} fixed>
      <View style={styles.logoContainer}>
        <Image src={logoDustre} style={styles.logo} />
        <Text style={styles.logoSubtitle}>Aços e Ligas Especiais</Text>
      </View>
      <View style={styles.headerContact}>
        <Text style={styles.email}>E-mail: qualidade@dustre.com.br</Text>
        <Text style={styles.contact}>
          Tel.: (11) 4556-0929 | Cel.: (11) 96165-6555
        </Text>
      </View>
    </View>
  )

  const renderFooter = () => (
    <View style={styles.footer} fixed>
      <Text style={styles.footerTextBold}>
        DUSTRE COMÉRCIO E FABRICAÇÃO DE LIGAS ESPECIAIS LTDA.
      </Text>
      <Text style={styles.footerText}>
        Av. Dr. Mauro Lindemberg Monteiro, 1.259 | Jardim Santa Fé | 06278-010 |
        Osasco - SP | Brasil
      </Text>
    </View>
  )

  const baseInfoFields = [
    {
      label: 'Nº do Certificado',
      en: 'Certificate Number',
      value: certificate.id,
    },
    { label: 'Nota Fiscal', en: 'Invoice', value: certificate.fiscalNote },
    { label: 'Cliente', en: 'Customer', value: certificate.customer },
    {
      label: 'Nº Pedido de compra',
      en: 'Purchase order number',
      value: certificate.purchaseOrderNumber,
    },
    { label: 'Descrição', en: 'Description', value: certificate.description },
    {
      label: 'Material de Partida',
      en: 'Starting Material',
      value: certificate.startingMaterial,
    },
    { label: 'Nº da Corrida', en: 'Heat', value: certificate.heatNumber },
    { label: 'Norma(s)', en: 'Specifications', value: certificate.norms },
    {
      label: 'Tratamento Térmico',
      en: 'Heat Treatment',
      value: certificate.heatTreatmentDetails,
    },
    {
      label: 'Usina de Fabricação',
      en: 'Manufacturing Plant',
      value: certificate.manufacturingPlant,
    },
  ]

  const infoFields = [...baseInfoFields]

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        {renderHeader()}

        <View style={styles.sectionTitleContainer}>
          <Text style={styles.sectionTitle}>CERTIFICADO DE QUALIDADE</Text>
          <Text style={styles.sectionSubtitle}>Quality Certificate</Text>
        </View>

        <View style={styles.infoBlock}>
          {infoFields.map((item, idx) => (
            <Text key={idx} style={styles.infoLine}>
              <Text style={styles.infoLabel}>{item.label}</Text>{' '}
              <Text style={styles.infoLabelSub}>({item.en}): </Text>
              <Text style={styles.infoValue}>
                {typeof item.value === 'string' ||
                typeof item.value === 'number'
                  ? item.value
                  : ''}
              </Text>
            </Text>
          ))}
        </View>

        {/* COMPOSIÇÃO QUÍMICA */}
        <View style={styles.sectionTitleContainer}>
          <Text style={styles.sectionBlack}>COMPOSIÇÃO QUÍMICA (%)</Text>
          <Text style={styles.sectionSubtitle}>Chemical Composition (%)</Text>
        </View>
        <View style={styles.dataRow}>
          {certificate.chemicalComposition.headersTop.map((el, i) => (
            <Text key={i} style={styles.dataCellHeader}>
              {el}
            </Text>
          ))}
        </View>
        <View style={styles.dataRow}>
          {Object.values(certificate.chemicalComposition.valuesTop).map(
            (val, i) => (
              <Text key={i} style={styles.dataCellValue}>
                {val ? val.replace('%', '') : '-'}
              </Text>
            ),
          )}
        </View>
        <View style={styles.dataRow}>
          {certificate.chemicalComposition.headersBottom.map((el, i) => (
            <Text key={i} style={styles.dataCellHeader}>
              {el}
            </Text>
          ))}
        </View>
        <View style={styles.dataRow}>
          {Object.values(certificate.chemicalComposition.valuesBottom).map(
            (val, i) => (
              <Text key={i} style={styles.dataCellValue}>
                {val ? val.replace('%', '') : '-'}
              </Text>
            ),
          )}
        </View>

        {/* ENSAIOS MECÂNICOS */}
        <View style={styles.sectionTitleContainer}>
          <Text style={styles.sectionBlack}>ENSAIOS MECÂNICOS</Text>
          <Text style={styles.sectionSubtitle}>Mechanical Tests</Text>
        </View>

        {/* Cabeçalho da tabela */}
        {/*         <View style={styles.tableHeader}>
          <Text style={styles.tableHeaderCell}>Item</Text>
          <Text style={styles.tableHeaderCell}>Item (English)</Text>
          <Text style={styles.tableHeaderCell}>Valor</Text>
        </View> */}

        {/* Linhas da tabela */}
        {certificate.mechanicalTests.headers.portuguese.map((label, i) => (
          <View key={i} style={styles.tableRow}>
            <Text style={styles.tableCell}>{label}</Text>
            <Text style={{ ...styles.tableCell, color: '#00BFD4' }}>
              {certificate.mechanicalTests.headers.english[i]}
            </Text>
            <Text style={styles.tableCellValue}>
              {Object.values(certificate.mechanicalTests.values)[i]
                ? Object.values(certificate.mechanicalTests.values)[i]
                : '-'}
            </Text>
          </View>
        ))}

        {/* OBSERVAÇÕES */}
        <View style={styles.observation}>
          <Text style={styles.observationTitle}>OBSERVAÇÕES (Comments)</Text>
          <Text style={styles.observationText}>
            {certificate.qualityObservations ||
              'Garantimos que o grau de redução do(s) forjado(s) e laminado(s) é de ao menos 3:1.'}
          </Text>
        </View>

        {/* ASSINATURA */}
        <View style={styles.parentSignatureContainer}>
          <View style={styles.signatureContainer}>
            <Image
              src={
                'https://storage.googleapis.com/certificates-uploads/signature.jpeg'
              }
              style={styles.signatureImage}
            />
            <Text style={styles.signatureTitle}>Gabriel Messias</Text>
            <Text style={styles.signatureTitle}>Controle de qualidade</Text>
            <Text style={styles.signatureSubtitle}>Quality Control</Text>
          </View>
        </View>

        <Text style={styles.locationDate}>{certificate.date}</Text>

        {renderFooter()}
      </Page>

      {/* PÁGINAS ADICIONAIS */}
      {certificate.additionalPages
        ?.filter((p) => p.imageLink || p.title || p.subtitle)
        .map((img, i) => (
          <Page key={i} size='A4' style={styles.page}>
            {renderHeader()}
            <View style={styles.additionalImageContainer}>
              <Text style={styles.imageTitle}>{img.title}</Text>
              {img.subtitle && (
                <Text style={styles.imageSubtitle}>{img.subtitle}</Text>
              )}
              {img.imageLink && (
                <Image
                  src={img.imageLink}
                  style={{
                    maxWidth: '100%',
                    maxHeight: 500,
                    objectFit: 'contain',
                  }}
                />
              )}
            </View>
            {renderFooter()}
          </Page>
        ))}
    </Document>
  )
}

export default CertificatePDFGenerator
